export default "__VITE_ASSET__Bzu$Sx4K__"